module.exports = {
    "bp-mobile-ss": "370px",
    "bp-mobile-s": "414px",
    "bp-mobile": "768px",
    "bp-tablet": "1024px",
    "bp-desktop": "1280px",
    "bp-desktop-l": "1600px",
  }
  